import * as React from 'react';
import {WrappedFieldProps} from 'redux-form';
import 'react-dates/initialize';
import {DateRangePicker, isInclusivelyAfterDay, isInclusivelyBeforeDay, isSameDay} from 'react-dates';
import isAfterDay from 'react-dates/lib/utils/isAfterDay';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
import Select from 'react-select';
import * as Dictionary from 'Models/Dictionary';
import {DateRange} from 'Models/EnumTypes/FormsEnumTypes';
import i18n from 'Translations/_i18n';
import {ReactNode} from "react";

type Props = {
  label: string;
  type: string;
  max?: number;
  min?: number;
  disabled: boolean;
  startDateLabel: string;
  endDateLabel: string;
  wrapperClassName?: string;
  dateRangePlaceholder?: string;
  additionalComponent?: ReactNode
};

type State = {
  focusedInput: any;
  selectValue: any;
};

class DatePickerRangeField extends React.PureComponent<WrappedFieldProps & Props, State> {
  constructor(props: WrappedFieldProps & Props) {
    super(props);
    this.state = {
      focusedInput: null,
      selectValue: this.props.meta.initial && this.props.meta.initial.enum
        ? {
          dateRange: Dictionary.DateRangeValuesMap.get(this.props.meta.initial.enum),
          label: i18n.t(`dictionary:${this.props.meta.initial.enum}`)
        }
        : null
    };
    this.handleFocusChange = this.handleFocusChange.bind(this);
  }

  public handleFocusChange = focusedInput => this.setState({focusedInput});

  public render() {
    const {input, startDateLabel, endDateLabel, disabled, wrapperClassName} = this.props;
    const {
      input: {
        // value: { startDate = null, endDate = null },
        onChange
      },
      meta,
      label,
      additionalComponent
    } = this.props;
    let formClasses: string = 'form-field ';
    formClasses += meta.error && meta.touched ? ' form-field--error' : '';
    formClasses += wrapperClassName ? ` ${wrapperClassName} ` : '';
    formClasses += disabled ? ' form-field--disabled' : '';
    const dateRangeOptions = Dictionary.generateDateRangesList();
    const {focusedInput} = this.state;
    return (
      <>
        <div className={formClasses}>
          <label className="form-field__label" htmlFor={input.name}>{label}</label>
          {additionalComponent}
          <div>
            <DateRangePicker
              endDateId="endDate"
              endDate={input.value.endDate}
              endDatePlaceholderText={endDateLabel}
              focusedInput={focusedInput}
              onDatesChange={e => {
                this.setState({selectValue: null});
                onChange(e);
              }}
              hideKeyboardShortcutsPanel
              onFocusChange={this.handleFocusChange}
              startDateId="startDate"
              startDate={input.value.startDate}
              minimumNights={0}
              startDatePlaceholderText={startDateLabel}
              isOutsideRange={(day) => !isInclusivelyBeforeDay(day, moment())}
            />
          </div>
        </div>
        <div className={formClasses}>
          <Select
            options={dateRangeOptions}
            classNamePrefix={'form-control'}
            components={{
              Option: CustomOption
            }}
            isSearchable={false}
            onChange={e => {
              this.setState({selectValue: e});
              onChange(e['value']);
            }}
            value={this.state.selectValue}
            placeholder={this.props.dateRangePlaceholder || 'Zakres dat'}
          />
          {(meta.touched &&
              (meta.error && (
                <div className="form-field__error">
                  {meta.error}
                </div>
              ))) ||
            (meta.warning && <span>{meta.warning}</span>)}
        </div>
      </>
    );
  }
}

const CustomOption = (props: any) => {
  moment.locale('pl');
  if (!props.isDisabled) {
    return (
      <div {...props.innerProps} className="form-control__option">
        {props.data.label}
        <span>{getCustomLabelForDateRangeSelect(props.data.value.startDate,
          props.data.value.endDate,
          props.data.value.enum)}</span>
      </div>
    );
  } else {
    return null;
  }
};

export default DatePickerRangeField;

function getCustomLabelForDateRangeSelect(firstDate: moment.Moment, secondDate: moment.Moment, labelEnum: DateRange) {
  const locale = moment.locale();
  switch (labelEnum) {
    case DateRange.TODAY:
    case DateRange.YESTERDAY:
      return firstDate.locale(locale).format('dddd');
    case DateRange.THIS_MONTH:
    case DateRange.LAST_MONTH:
      return firstDate.locale(locale).format('MMMM');
    case DateRange.THIS_YEAR:
    case DateRange.LAST_YEAR:
      return firstDate.locale(locale).format('YYYY');
    default:
      return `${firstDate.locale(locale).format('DD-MM')} - ${secondDate.locale(locale).format('DD-MM')}`;
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/DatePickerRangeField.tsx